import React, { useLayoutEffect, useRef } from 'react';
import './chapters.scss';
import Quotes from '../Quotes/Quotes';
import { gsap, ScrollTrigger } from '../../gsap';

function Chapter({ data }) {
  const headRef = useRef();
  const { head, copy, quotes } = data;
  useLayoutEffect(() => {
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0.3) {
            entry.target.style.animation = 'fade-up 0.5s linear forwards';
          }
        });
      },
      { threshold: [0, 0.3] }
    );

    observer.observe(headRef.current);
  }, []);

  useLayoutEffect(() => {
    ScrollTrigger.batch('.quotes', {
      onEnter: (batch) => gsap.to(batch, { opacity: 1, y: 0, duration: 0.7 })
    });
  }, []);

  return (
    <div className="chapters__chapter">
      <div className="chapters__chapter__head" ref={headRef}>
        <h4>{head}</h4>
        <p>{copy}</p>
      </div>
      {quotes.map((el, i) => {
        const cl = i % 2 ? 'odd' : 'even';
        return <Quotes data={el} cl={cl} key={i} />;
      })}
    </div>
  );
}

export default Chapter;
